var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTennisBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_418_6798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9985 29.9971C27.282 29.9971 33.9971 23.282 33.9971 14.9985C33.9971 6.71507 27.282 0 18.9985 0C10.7151 0 4 6.71507 4 14.9985C4 23.282 10.7151 29.9971 18.9985 29.9971Z",
    fill: "#94E061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7555 29.3838C13.809 29.1055 12.8901 28.7336 12.0136 28.273C13.0375 25.3113 13.1848 21.6808 11.2113 18.5145C9.51258 15.7894 6.73807 14.1837 4.0752 13.4792C4.1706 12.5543 4.35108 11.6415 4.61367 10.7529C8.29248 11.2914 11.8989 13.7955 14.0293 17.7194C16.1537 21.6325 16.2937 26.0085 14.7555 29.3838Z",
    fill: "#E9EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1542 28.1797C19.4624 31.8126 11.2276 29.8265 6.87207 23.8272C11.4606 27.9104 18.2931 28.9005 24.0021 25.8012C31.2819 21.8489 33.9791 12.7436 30.0268 5.4638C29.7075 4.87581 29.3549 4.318 28.9716 3.79102C30.2339 4.91384 31.3266 6.27153 32.1796 7.84235C36.1319 15.1221 33.434 24.2274 26.1542 28.1797Z",
    fill: "#70CF3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.401 27.5499C15.2374 28.1862 15.0219 28.7995 14.7557 29.3833C14.6965 29.3658 14.6373 29.3483 14.5788 29.3302C14.087 29.1781 13.6025 29.0017 13.1279 28.8006C13.0463 28.7659 12.005 28.298 12.0137 28.2725C12.1622 27.8427 12.2926 27.3984 12.4001 26.9438C13.3757 27.2469 14.3814 27.4503 15.401 27.5499Z",
    fill: "#D3DCE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9298 16.4261C33.8428 17.3335 33.6732 18.2294 33.4239 19.1023C29.8283 18.4925 26.33 16.0126 24.2455 12.1726C22.1555 8.32295 21.9853 4.02597 23.4456 0.674316C24.3276 0.948386 25.1842 1.30274 26.004 1.73497C25.1443 4.32776 24.9681 7.48926 26.2872 10.3784C27.8277 13.7548 30.9108 15.6359 33.9298 16.4261Z",
    fill: "#E9EFF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9295 16.4257C33.8959 16.7767 33.8506 17.1127 33.7942 17.4598C33.773 17.5904 33.4494 19.1062 33.4236 19.1018C32.5133 18.9473 31.609 18.6732 30.7324 18.2868C31.091 17.4066 31.3657 16.4945 31.5528 15.563C32.3297 15.9319 33.132 16.2168 33.9295 16.4257Z",
    fill: "#D3DCE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9295 16.4256C33.9187 16.5391 33.9066 16.6519 33.8933 16.7649C33.8867 16.8216 33.8794 16.8778 33.8722 16.9345C33.8643 16.9906 33.8571 17.0474 33.8486 17.1035C33.842 17.1518 33.8347 17.2001 33.8275 17.2484C33.8173 17.319 33.8058 17.3891 33.7943 17.4597C33.7822 17.5292 33.7702 17.5992 33.7575 17.6686C33.7539 17.6885 33.7502 17.7084 33.7466 17.7284C33.7333 17.8002 33.7195 17.872 33.7049 17.9439C33.7049 17.9445 33.7049 17.9451 33.7044 17.9457C33.6893 18.0218 33.6736 18.0972 33.6567 18.1727C33.647 18.2198 33.6361 18.2669 33.6252 18.314C33.6156 18.3568 33.6059 18.3997 33.5957 18.4426C33.583 18.4981 33.5691 18.5537 33.5552 18.6086C33.5413 18.6635 33.5274 18.7185 33.513 18.7734C33.4846 18.8833 33.455 18.9926 33.4236 19.1018C32.5133 18.9473 31.609 18.6732 30.7324 18.2868C31.091 17.4066 31.3657 16.4945 31.5528 15.563C32.3298 15.9318 33.1321 16.2167 33.9295 16.4256Z",
    fill: "#D3DCE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_418_6798",
    x: 0,
    y: 0,
    width: 38,
    height: 41.9995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_418_6798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_418_6798",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisBall);
export default __webpack_public_path__ + "static/media/tennis-ball.ff1efefee31006256dad2629966bd80f.svg";
export { ForwardRef as ReactComponent };